module.exports = __webpack_public_path__ + "static/shape-b71e8755a70073ec5659344792ab8646.png";